import Btn from 'components/buttons/Btn'
import OrderContext from 'pages/Order/_context'
import CardInfoModal from 'pages/Order/Header/CardInfoModal'
import Ellipsis from 'pages/Order/Header/Ellipsis'
import CancelDriverModal from 'pages/Order/Modals/CancelDriverModal'
import InHouseDeliveryModal from 'pages/Order/Modals/InHouseDeliveryModal'
import RequestDriverModal from 'pages/Order/Modals/RequestDriverModal'
import { useContext } from 'react'
import { ButtonGroup, Col, Row } from 'react-bootstrap'
import { useTranslation } from 'react-i18next'
import { useAccount } from 'state/Account'
import { useUser } from 'state/Auth'
import { PRIVILEGES, useServerConstants } from 'state/Constants'
import { useModalState } from 'utils'

export default function TypeAndPmtRow({ temp }) {
	const { t }     = useTranslation()
	const CONSTANTS = useServerConstants()

	/** @type Order */
	const order       = useContext(OrderContext)
	const account     = useAccount()
	const showInHouse = order.canToggleInHouse(account)

	const cardModal            = useModalState()
	const requestDriverModal   = useModalState()
	const cancelDriverModal    = useModalState()
	const inHouseDeliveryModal = useModalState()

	/** additional props for the cardInfo button, in case the related privilege is missing */
	const cardBtnPrivCheck = useUser().usePrivilege(PRIVILEGES().PAYMENTINFO, true)? {} : {
		noSlash   : true, //it may seem like there's actually no card available
		disabled  : true,
		tooltipTxt: t('Currently, you have no permission to see card details.')+' '+t('CONTACT_ERROR')
	}

	return <Row className="types-row">
		<Col xs="auto">
				<span className="d-flex align-items-center mr-0">
					<order.type.Icon fixedWidth className="mr-1"/>
					{order.type.name}
					<order.comp.deliveryBadge t={t}/>
				</span>

			{!temp && account.isShipdayOn(CONSTANTS.VALUES) && order.is_delivery && <>
				<ButtonGroup className="mt-2 d-print-none">
					{order.can_deliver_with_shipday?
						<>
							{order.shipday.is_cancelable &&
								<DlvyBtn variant="outline-danger" onClick={cancelDriverModal.doOpen}>{t('Cancel driver')}</DlvyBtn>}

							{order.shipday.is_trackable &&
								<DlvyBtn onClick={() => window.open(order.shipday.tracking_url)} icon="map-marked-alt">
									{t('Track', { context: '...delivery (button)'})}
								</DlvyBtn>}

							{order.shipday.is_requestable ?
								(account.shipday_globally_disabled ? (
									<DlvyBtn onClick={requestDriverModal.doOpen} swap disabled
									         tooltipTxt={t("It's not possible to request a third-party driver due to a service interruption")}>
										{t('Third-party')}
									</DlvyBtn>
								)
								:
								(<DlvyBtn onClick={requestDriverModal.doOpen} swap
								     disabled={!order.is_paid}
								     tooltipTxt={!order.is_paid && t('Right now, it\'s not possible to request delivery services for unpaid orders.')}>
									{!order.is_paid? t('Unpaid') :
										(order.deliver_by_ourselves? t('Request driver instead') :
											t('Third-party', { context: '...driver' }) // <Trans>3<sup>rd</sup> party</Trans>
										)}
								</DlvyBtn>)
								) : null
							}
						</>
						:
						<DlvyBtn onClick={requestDriverModal.doOpen} swap disabled
						     tooltipTxt={t("It's not possible to request a third-party driver: this order is outside your delivery zone.")}>
							{t('Too far')}
						</DlvyBtn>
					}
					{showInHouse && <DlvyBtn onClick={inHouseDeliveryModal.doOpen}>{t('In-house', { context: '...driver' })}</DlvyBtn>}
				</ButtonGroup>

				{/* for some reason, these were showing zeroes in some scenarios when the `&&` trick was used? */}
				{order.shipday.is_requestable? <RequestDriverModal {...requestDriverModal}/> : null}
				{order.shipday.is_cancelable? <CancelDriverModal {...cancelDriverModal}/> : null}
				{showInHouse? <InHouseDeliveryModal {...inHouseDeliveryModal}/> : null}
				{/*<TrackDeliveryModal {...trackDeliveryModal}/> Not in use because Uber tracking gets blocked on the current Shipday plan */}
			</>}
		</Col>

		<Col>
			{temp?
				<Ellipsis/>
				:
				//this button doesn't fit with Shipday details in a small screen, but in practice it never happens - Shipday won't be requested for unpaid orders
				(order.should_show_card_info?
						<>
							<Btn variant="danger" onClick={cardModal.doOpen} style={{lineHeight: '1rem', whiteSpace:'nowrap'}} icon="credit-card" swap {...cardBtnPrivCheck}>
								{CONSTANTS.paymentText(order)}<br/>
								<small className="d-print-none">{t('See card details')}</small>
							</Btn>
							<CardInfoModal {...cardModal}/>
						</>
						:
						<span className={`d-flex flex-row flex-wrap justify-content-end align-items-center text-${order.is_captured? 'success' : 'danger'}`}>
							{/* flex so it centers the badge, and the rest makes it wrap to the right if there's too much stuff */}
							{CONSTANTS.paymentText(order)}
							<order.comp.pmtStatus/>
						</span>
				)
			}
		</Col>
	</Row>
}

/** A shorter version of the usual {@link Btn} with the same size and color, in case it changes again... */
function DlvyBtn(props) {
	return <Btn size="sm" variant="outline-dark" {...props}/>
}
